import React, { useEffect, useState, useCallback } from "react";
import {
  // ИЗМЕНЕНО: Добавлена функция summaryAll, убраны замененные
  summaryAll,
  lowStock,
  recentActs,
  countAppUsers,
  countActiveAssignments,
  actsTodayByType,
  movesLast7Days,
  stockByCategory,
  totalInventoryValue,
} from "api/dashboard";
import { Button } from "components/ui/Button";

/* =========================
   Иконки (без изменений)
   ========================= */
const Icons = {
  Items: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
      />
    </svg>
  ),
  Stock: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"
      />
    </svg>
  ),
  Acts: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
      />
    </svg>
  ),
  Users: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-4.663M12 12a3 3 0 100-6 3 3 0 000 6z"
      />
    </svg>
  ),
  Assignments: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5"
      />
    </svg>
  ),
  Value: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.75A.75.75 0 013 4.5h.75m0 0A.75.75 0 014.5 3v.75m0 0v-.75A.75.75 0 014.5 3h.75m0 0v.75A.75.75 0 016 3h.75m0 0v.75A.75.75 0 016.75 3h.75m0 0v.75A.75.75 0 017.5 3v.75m0 0A.75.75 0 018.25 3v.75m0 0v-.75a.75.75 0 01.75-.75h.75m0 0A.75.75 0 0110.5 3v.75m0 0v-.75A.75.75 0 0110.5 3h.75m0 0v.75A.75.75 0 0112 3v.75m0 0v-.75a.75.75 0 01.75-.75h.75m0 0A.75.75 0 0113.5 3v.75m0 0v-.75A.75.75 0 0113.5 3h.75m0 0v.75A.75.75 0 0115 3v.75m0 0A.75.75 0 0115.75 3v.75m0 0v-.75A.75.75 0 0115.75 3h.75M15 12a3 3 0 11-6 0 3 3 0 016 0z"
      />
    </svg>
  ),
  Refresh: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0011.664 0l3.18-3.185m-7.5 0v4.992"
      />
    </svg>
  ),
};

const ActivityIcons = {
  in: (
    <div className="h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center">
      <svg
        className="h-5 w-5 text-blue-600"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    </div>
  ),
  out: (
    <div className="h-8 w-8 rounded-full bg-yellow-100 flex items-center justify-center">
      <svg
        className="h-5 w-5 text-yellow-600"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    </div>
  ),
  return: (
    <div className="h-8 w-8 rounded-full bg-green-100 flex items-center justify-center">
      <svg
        className="h-5 w-5 text-green-600"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    </div>
  ),
};

/* =========================
   Страница
   ========================= */
export default function DashboardPage() {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);

  const loadData = useCallback(async () => {
    setLoading(true);
    setErr(null);
    try {
      // ===== ИЗМЕНЕНИЕ: Promise.all перестроен для использования summaryAll =====
      const [summary, k4, k5, k6, todayTypes, def, acts, moves7d, byCat] =
        await Promise.all([
          summaryAll(), // Новый объединенный вызов
          countAppUsers(),
          countActiveAssignments(),
          totalInventoryValue(),
          actsTodayByType(),
          lowStock(5),
          recentActs(7),
          movesLast7Days(),
          stockByCategory(),
        ]);

      const activity = (acts || [])
        .map((a) => ({
          id: a.id,
          type: a.act_type,
          date: a.created_at,
          user: a.app_user_name,
          title: a.act_no,
        }))
        .sort((a, b) => new Date(b.date) - new Date(a.date));

      // ===== ИЗМЕНЕНИЕ: setData использует данные из summary =====
      setData({
        k1: summary.current_balance_qty, // k1 = Total Assets (Warehouse + Issued)
        k2: summary.warehouse_qty, // k2 = Warehouse
        k3: summary.issued_qty, // k3 = Issued (NEW)
        k4,
        k5,
        k6, // Total Value (now includes issued)
        todayTypes,
        def,
        activity,
        moves7d,
        byCat,
      });
    } catch (e) {
      console.error("Dashboard fetch error:", e);
      setData({});
      setErr(e.message || "Ma'lumotlarni yuklab bo'lmadi");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  if (loading && !Object.keys(data).length) return <SkeletonDashboard />;

  const { k1, k2, k3, k4, k5, k6, activity, moves7d, byCat, def } = data;

  return (
    <div className="bg-slate-100 dark:bg-slate-900 min-h-screen transition-colors">
      <div className="max-w-screen-xl mx-auto p-4 sm:p-6 lg:p-8 space-y-8">
        <header className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div>
            <h1 className="text-3xl font-bold tracking-tight text-slate-900 dark:text-slate-100">
              Xush kelibsiz!
            </h1>
            <p className="mt-1 text-slate-600 dark:text-slate-400">
              Bugungi ombor ko'rsatkichlari.
            </p>
          </div>
          <Button
            variant="outline"
            onClick={loadData}
            disabled={loading}
            className="bg-white group transition-all duration-200 hover:shadow-lg"
          >
            <Icons.Refresh
              className={`h-5 w-5 ${loading
                ? "animate-spin"
                : "group-hover:rotate-90 transition-transform"
                }`}
            />
            Yangilash
          </Button>
        </header>

        {err && (
          <Panel>
            <div className="flex items-center justify-between gap-4">
              <p className="text-sm text-rose-600">Xatolik: {err}</p>
              <Button variant="outline" onClick={loadData} disabled={loading}>
                Qayta urinish
              </Button>
            </div>
          </Panel>
        )}

        <div className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <KPI
              icon={<Icons.Value />}
              label="Umumiy aktiv"
              value={fmtMoney(k6)}
            />
            <KPI icon={<Icons.Stock />} label="Jami (Ombor)" value={k2} />
            <KPI icon={<Icons.Assignments />} label="Berilgan (Xodimda)" value={k3} />
            <KPI icon={<Icons.Items />} label="Jami mahsulot (Aktiv)" value={k1} />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <KPI icon={<Icons.Assignments />} label="Faol topshiriqlar" value={k5} />
            <KPI icon={<Icons.Users />} label="Foydalanuvchilar" value={k4} />
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          <Panel className="lg:col-span-3">
            <h3 className="font-semibold text-slate-800">7 kunlik harakatlar</h3>
            <div className="h-80 -mx-2 -mb-2 mt-4">
              <MovesChart data={moves7d || []} />
            </div>
          </Panel>
          <Panel className="lg:col-span-2">
            <h3 className="font-semibold text-slate-800">
              Toifalar bo'yicha qoldiqlar
            </h3>
            <div className="h-80">
              <CategoryChart data={byCat?.slice?.(0, 5) ?? []} />
            </div>
          </Panel>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          <Panel className="lg:col-span-3">
            <h3 className="font-semibold text-slate-800">
              Kritik qoldiq
            </h3>
            <DeficitList items={def} />
          </Panel>
          <Panel className="lg:col-span-2">
            <h3 className="font-semibold text-slate-800">So'nggi hodisalar</h3>
            <ActivityFeed items={activity} />
          </Panel>
        </div>
      </div>
    </div>
  );
}

/* =========================
   UI-компоненты (без изменений)
   ========================= */
const Panel = ({ className = "", children }) => (
  <div
    className={`bg-white dark:bg-slate-800 p-5 rounded-2xl border border-slate-200/90 dark:border-slate-700/90 shadow-lg shadow-slate-200/40 dark:shadow-slate-900/40 transition-colors ${className}`}
  >
    {children}
  </div>
);

const KPI = ({ icon, label, value }) => (
  <Panel className="flex items-center gap-5 transition-all duration-300 hover:shadow-xl hover:scale-[1.03] hover:border-violet-300">
    <div className="flex-shrink-0 h-12 w-12 flex items-center justify-center bg-gradient-to-br from-violet-100 to-blue-100 text-violet-600 rounded-xl">
      {icon && React.cloneElement(icon, { className: "h-6 w-6" })}
    </div>
    <div className="min-w-0">
      <p className="text-sm text-slate-500 dark:text-slate-400">{label}</p>
      <p className="text-2xl font-bold text-slate-900 dark:text-slate-100 leading-tight truncate">
        {value ?? "0"}
      </p>
    </div>
  </Panel>
);

const DeficitList = ({ items }) => {
  if (!items || items.length === 0)
    return <Empty>Barcha mahsulotlar yetarli</Empty>;
  return (
    <ul className="mt-2 space-y-1">
      {items.map((item) => (
        <li
          key={item.id}
          className="p-2 -mx-2 flex items-center gap-4 rounded-lg transition-colors hover:bg-rose-50"
        >
          <div className="flex-shrink-0 h-10 w-1 flex bg-rose-500 rounded-full" />
          <div className="flex-grow min-w-0">
            <p className="font-medium text-slate-800 dark:text-slate-200 truncate">{item.name}</p>
            <p className="text-sm text-slate-500 dark:text-slate-400">
              Qoldi{" "}
              <span className="font-semibold text-rose-600">
                {item.qty_on_hand}
              </span>
              , minimum{" "}
              <span className="font-semibold text-slate-600">
                {item.min_stock}
              </span>
            </p>
          </div>
          <div className="text-right flex-shrink-0">
            <p className="font-semibold text-rose-600 font-mono">
              {item.deficit}
            </p>
            <p className="text-xs text-slate-400">defitsit</p>
          </div>
        </li>
      ))}
    </ul>
  );
};

const ActivityFeed = ({ items }) => {
  if (!items || items.length === 0) return <Empty>So'nggi hodisalar yo'q</Empty>;
  const typeMap = { in: "Kirim", out: "Chiqim", return: "Qaytarish" };
  return (
    <ul className="mt-2 space-y-1">
      {items.map((item, i) => (
        <li
          key={`${item.id}-${i}`}
          className="flex items-center gap-3 p-2 -mx-2 rounded-lg hover:bg-slate-50"
        >
          {ActivityIcons[item.type]}
          <div className="min-w-0 flex-grow">
            <p className="text-sm font-medium text-slate-800 dark:text-slate-200 truncate">
              {item.user || "Tizim"}
            </p>
            <p className="text-xs text-slate-500 dark:text-slate-400 truncate">
              {typeMap[item.type]}: {item.title}
            </p>
          </div>
          <span className="text-xs text-slate-400 flex-shrink-0">
            {new Date(item.date).toLocaleTimeString("ru-RU", {
              hour: "2-digit",
              minute: "2-digit",
            })}
          </span>
        </li>
      ))}
    </ul>
  );
};

const Empty = ({ children }) => (
  <div className="flex items-center justify-center h-full min-h-[10rem] text-sm text-slate-500 dark:text-slate-400">
    {children}
  </div>
);

/* =========================
   Графики (без изменений)
   ========================= */
const MovesChart = ({ data = [] }) => {
  const w = 500,
    h = 250,
    margin = { top: 20, right: 20, bottom: 30, left: 40 };
  const innerWidth = w - margin.left - margin.right;
  const innerHeight = h - margin.top - margin.bottom;
  if (!data.length) return <Empty>Grafik uchun ma'lumot yetarli emas</Empty>;

  const maxVal = Math.max(
    10,
    ...data.map((d) => Math.max(d.in, d.out, d.return))
  );
  const xScale = (i) => margin.left + (i / (data.length - 1)) * innerWidth;
  const yScale = (v) => h - margin.bottom - (v / maxVal) * innerHeight;

  const linePath = (key, color) => {
    const start = `M${xScale(0)} ${yScale(data[0][key])}`;
    const line = data
      .map((d, i) => `L${xScale(i)} ${yScale(d[key])}`)
      .join(" ");
    return { path: `${start} ${line}`, color };
  };

  const lines = [
    linePath("in", "#4f46e5"),
    linePath("out", "#f97316"),
    linePath("return", "#10b981"),
  ];

  return (
    <div className="relative">
      <svg viewBox={`0 0 ${w} ${h}`} className="w-full h-full">
        {[0.25, 0.5, 0.75, 1].map((p) => (
          <line
            key={p}
            x1={margin.left}
            x2={w - margin.right}
            y1={yScale(maxVal * p)}
            y2={yScale(maxVal * p)}
            stroke="#e2e8f0"
            strokeDasharray="2,3"
          />
        ))}
        {lines.map((l) => (
          <path
            key={l.color}
            d={l.path}
            fill="none"
            stroke={l.color}
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        ))}
        <line
          x1={margin.left}
          x2={w - margin.right}
          y1={h - margin.bottom}
          y2={h - margin.bottom}
          stroke="#cbd5e1"
        />
        {data.map((d, i) => (
          <text
            key={d.date}
            x={xScale(i)}
            y={h - margin.bottom + 15}
            textAnchor="middle"
            className="text-xs fill-slate-500"
          >
            {d.date.slice(5)}
          </text>
        ))}
        <text
          x={margin.left - 8}
          y={margin.top}
          textAnchor="end"
          className="text-xs fill-slate-500 font-semibold"
        >
          {maxVal}
        </text>
        <text
          x={margin.left - 8}
          y={h - margin.bottom + 4}
          textAnchor="end"
          className="text-xs fill-slate-500 font-semibold"
        >
          0
        </text>
      </svg>
    </div>
  );
};

const CategoryChart = ({ data = [] }) => {
  const colors = ["#6366f1", "#818cf8", "#a78bfa", "#c4b5fd", "#ddd6fe"];
  const total = data.reduce((s, x) => s + x.qty, 0);
  if (!total) return <Empty>Toifalar bo'yicha ma'lumot yo'q</Empty>;
  let acc = 0;

  return (
    <div className="flex flex-col md:flex-row items-center justify-center gap-8 h-full">
      <div className="relative w-40 h-40 flex-shrink-0">
        <svg viewBox="0 0 36 36" className="transform -rotate-90">
          {data.map((d, i) => {
            const pct = (d.qty / total) * 100;
            const offset = acc;
            acc += pct;
            return (
              <circle
                key={d.id}
                cx="18"
                cy="18"
                r="15.915"
                fill="transparent"
                stroke={colors[i % colors.length]}
                strokeWidth="4"
                strokeDasharray={`${pct} ${100 - pct}`}
                strokeDashoffset={25 - offset}
                className="transition-all duration-500"
              />
            );
          })}
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="text-3xl font-bold text-slate-800 dark:text-slate-100">{total}</span>
          <span className="text-xs text-slate-500 dark:text-slate-400">jami</span>
        </div>
      </div>
      <ul className="space-y-2 text-sm w-full">
        {data.map((d, i) => (
          <li key={d.id} className="flex items-center gap-2">
            <span
              className="h-3 w-3 rounded-sm"
              style={{ backgroundColor: colors[i % colors.length] }}
            />
            <span className="font-medium text-slate-700 dark:text-slate-300">{d.name}</span>
            <span className="text-slate-500 dark:text-slate-400 ml-auto pl-4 font-mono">
              {((d.qty / total) * 100).toFixed(0)}%
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

/* =========================
   Skeleton (без изменений)
   ========================= */
const SkeletonDashboard = () => (
  <div className="p-4 sm:p-6 lg:p-8 bg-slate-100 dark:bg-slate-900 min-h-screen animate-pulse">
    <div className="max-w-screen-xl mx-auto space-y-8">
      <header className="flex items-center justify-between">
        <div>
          <div className="h-8 bg-slate-300 rounded-lg w-64 mb-2" />
          <div className="h-5 bg-slate-200 rounded-lg w-80" />
        </div>
        <div className="h-10 bg-white border border-slate-200 rounded-lg w-32" />
      </header>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div className="h-24 bg-white rounded-2xl border border-slate-200/90" />
        <div className="h-24 bg-white rounded-2xl border border-slate-200/90" />
        <div className="h-24 bg-white rounded-2xl border border-slate-200/90" />
        <div className="h-24 bg-white rounded-2xl border border-slate-200/90" />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
        <div className="lg:col-span-3 h-96 bg-white rounded-2xl border border-slate-200/90" />
        <div className="lg:col-span-2 h-96 bg-white rounded-2xl border border-slate-200/90" />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
        <div className="lg:col-span-3 h-80 bg-white rounded-2xl border border-slate-200/90" />
        <div className="lg:col-span-2 h-80 bg-white rounded-2xl border border-slate-200/90" />
      </div>
    </div>
  </div>
);

/* =========================
   Вспомогательная функция (без изменений)
   ========================= */
const fmtMoney = (v) => {
  try {
    return new Intl.NumberFormat("ru-RU", {
      style: "currency",
      currency: "UZS",
      maximumFractionDigits: 0,
    }).format(v || 0);
  } catch {
    return `${Math.round(v || 0)} so'm`;
  }
};
